import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { productsOptions } from '../data-provider';
import type { ProductsParams } from '../models';

export const useProducts = (params: ProductsParams) => useQuery(productsOptions(params));
export const useSuspenseProducts = (params: ProductsParams) => useSuspenseQuery(productsOptions(params));
